import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, StarIcon, PlayCircleIcon, CheckIcon, ServerIcon, InfinityIcon, ReceiptIcon } from 'lucide-react';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant1() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const wordItem = {
    hidden: {
      opacity: 0,
      y: 20,
      filter: 'blur(8px)'
    },
    show: {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-264">
        {/* Background Glow */}
        <div className="absolute top-1/4 left-0 w-[800px] h-[600px] opacity-30 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at center, var(--accent) 0%, transparent 70%)'
      }} data-id="element-265" />

        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-266">
          {/* Left Column - Text & CTAs */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-267">
            {/* Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-4 md:mb-6 bg-white/50 backdrop-blur-sm shadow-sm" style={{
            borderColor: 'var(--border)'
          }} data-id="element-268">
              <span className="text-xs md:text-sm font-semibold tracking-wide text-gray-800 flex items-center gap-1.5" data-id="element-269">
                🔥 Более 500+ запущенных сайтов
              </span>
            </motion.div>

            {/* Title */}
            <motion.h1 variants={container} initial="hidden" animate="show" className="mb-6 md:mb-8 text-4xl leading-tight tracking-tight md:text-5xl lg:text-[3.5rem] font-bold max-w-2xl" style={{
            color: 'var(--text-primary)'
          }} data-id="element-270">
              <motion.span variants={wordItem} className="block mb-1" data-id="element-271">
                Сделаем сайт
              </motion.span>
              <motion.span variants={wordItem} className="relative inline-block mb-2" data-id="element-272">
                <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 uppercase tracking-wider font-black" data-id="element-273">
                  БЕСПЛАТНО.
                </span>
                {/* Marker highlight effect */}
                <div className="absolute bottom-2 left-0 w-full h-4 bg-blue-200/40 -rotate-2 skew-x-12" data-id="element-274" />
              </motion.span>
              <br data-id="element-275" />
              <motion.span variants={wordItem} className="inline-block" data-id="element-276">
                Платишь только{' '}
                <span style={{
                color: 'var(--accent)'
              }} data-id="element-277">
                  $15/мес.
                </span>
              </motion.span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="text-base sm:text-lg md:text-xl mb-6 max-w-xl text-gray-600 font-medium" data-id="element-278">
              Сначала макет — потом решение. Не понравится — уходишь без оплаты.
            </motion.p>

            {/* Value Pills */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="flex flex-wrap gap-3 mb-10" data-id="element-279">
              <div className="flex items-center gap-1.5 bg-green-50 text-green-700 px-3 py-1.5 rounded-lg text-sm font-semibold border border-green-100 shadow-sm" data-id="element-280">
                <CheckIcon className="w-4 h-4" data-id="element-281" /> 0$ за разработку
              </div>
              <div className="flex items-center gap-1.5 bg-blue-50 text-blue-700 px-3 py-1.5 rounded-lg text-sm font-semibold border border-blue-100 shadow-sm" data-id="element-282">
                <ServerIcon className="w-4 h-4" data-id="element-283" /> Хостинг включен
              </div>
              <div className="flex items-center gap-1.5 bg-purple-50 text-purple-700 px-3 py-1.5 rounded-lg text-sm font-semibold border border-purple-100 shadow-sm" data-id="element-284">
                <InfinityIcon className="w-4 h-4" data-id="element-285" /> Безлимитные правки
              </div>
            </motion.div>

            {/* CTA Buttons */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} className="flex flex-col sm:flex-row gap-4 items-center justify-start mb-12 w-full sm:w-auto" data-id="element-286">
              <button onClick={() => setIsPopupOpen(true)} className="group relative w-full sm:w-auto flex items-center justify-center gap-2 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 overflow-hidden" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-287">
                {/* Button Glow Effect */}
                <div className="absolute inset-0 w-full h-full bg-white/20 group-hover:translate-x-full -translate-x-full transition-transform duration-500 skew-x-12" data-id="element-288" />
                Получить бесплатный макет
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-289" />
              </button>

              <a href="#how-it-works" className="flex items-center justify-center gap-2 px-8 py-4 rounded-2xl font-semibold text-gray-700 hover:bg-gray-100 transition-colors w-full sm:w-auto" data-id="element-290">
                <PlayCircleIcon className="w-5 h-5" data-id="element-291" />
                Как это работает
              </a>
            </motion.div>

            {/* Social Proof */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 1
          }} className="flex items-center gap-3" data-id="element-292">
              <div className="flex gap-1" data-id="element-293">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-294" />)}
              </div>
              <span className="text-sm font-medium text-gray-600" data-id="element-295">
                Средняя оценка 4.9/5 от наших клиентов
              </span>
            </motion.div>
          </div>

          {/* Right Column - Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0 flex items-center justify-center" data-id="element-296">
            <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-2xl border border-[var(--border)]" data-id="element-297">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-298" />
            </div>

            {/* Floating Invoice Card (The WOW Factor) */}
            <motion.div initial={{
            opacity: 0,
            x: -30,
            y: 30
          }} animate={{
            opacity: 1,
            x: 0,
            y: 0
          }} transition={{
            delay: 1.2,
            duration: 0.8,
            type: 'spring',
            stiffness: 100
          }} className="absolute -bottom-6 -left-6 sm:-left-10 bg-white/95 backdrop-blur-xl p-5 rounded-2xl shadow-2xl border border-gray-100 w-64 hidden sm:block z-20" data-id="element-299">
              <div className="flex items-center gap-2 mb-3 border-b border-gray-100 pb-2" data-id="element-300">
                <ReceiptIcon className="w-4 h-4 text-gray-400" data-id="element-301" />
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-302">
                  Ваш чек
                </span>
              </div>
              <div className="space-y-2 mb-3" data-id="element-303">
                <div className="flex justify-between text-sm" data-id="element-304">
                  <span className="text-gray-600" data-id="element-305">Дизайн сайта</span>
                  <span className="font-bold text-green-500" data-id="element-306">$0</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-307">
                  <span className="text-gray-600" data-id="element-308">Разработка</span>
                  <span className="font-bold text-green-500" data-id="element-309">$0</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-310">
                  <span className="text-gray-600" data-id="element-311">Поддержка</span>
                  <span className="font-bold text-gray-900" data-id="element-312">$15/мес</span>
                </div>
              </div>
              <div className="border-t border-gray-100 pt-3 flex justify-between items-center" data-id="element-313">
                <span className="text-sm font-bold text-gray-900" data-id="element-314">
                  Итого к оплате
                </span>
                <span className="text-xl font-black text-[var(--accent)]" data-id="element-315">
                  $15
                </span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-316" />
    </>;
}